<template>
    <div>
        <ModalApp name="pix_modal" style="overflow-y: auto;">
            <div class="modal-body">
                <div class="d-flex flex-column align-items-center">
                    <c-heading-3
                        class="text-center"
                        style="padding-bottom:10px"
                        >{{ gateway.nome_razao_social }}</c-heading-3
                    >
                    <img
                        style="width:auto; max-height:200px"
                        :src="purchase.payment_link"
                    />
                    <div style="width:80%">
                        <c-paragraph
                            class="text-center"
                            style="margin-top: 30px;"
                            >{{ gateway.pix_msg }}</c-paragraph
                        >
                    </div>
                </div>
                <div class="d-sm-flex justify-content-sm-between">
                    <c-heading-4 class="mt-2 mb-1 mb-sm-0"
                        >Total:
                        {{ currency.money(purchase.valor_total) }}</c-heading-4
                    >
                    <c-button
                        :backgroundColor="
                            $root.$children[0].theme.products.button
                                .background_color
                        "
                        :backgroundColorHover="
                            $root.$children[0].theme.products.button
                                .background_color_hover
                        "
                        :color="$root.$children[0].theme.products.button.color"
                        :colorHover="
                            $root.$children[0].theme.products.button.color_hover
                        "
                        :borderColor="
                            $root.$children[0].theme.products.button
                                .border_color
                        "
                        :borderColorHover="
                            $root.$children[0].theme.products.button
                                .border_color_hover
                        "
                        :borderRadius="
                            $root.$children[0].theme.products.button
                                .border_radius
                        "
                        margin="0px"
                        textTransform="uppercase"
                        height="unset"
                        minWidth="124px"
                        padding="0.5rem 2rem"
                        display="inline-block"
                        textAlign="center"
                        lineHeight="1.5"
                        letterSpacing="0.8px"
                        transition="all .3s"
                        fontSize="1.4rem"
                        type="button"
                        v-clipboard:copy="pix_data.payload_pix"
                        v-clipboard:success="onCopyPix"
                        v-clipboard:error="onErrorPix"
                    >
                        Copiar chave
                    </c-button>
                </div>
            </div>
            <div class="modal-footer float-right">
                <c-button
                    type="button"
                    data-dismiss="modal"
                    backgroundColor="#dc3545"
                    backgroundColorHover="#bd2130"
                    color="#fff"
                    colorHover="#fff"
                    :textTransform="
                        $root.$children[0].theme.products.button.text_transform
                    "
                    :borderRadius="
                        $root.$children[0].theme.products.button.border_radius
                    "
                    borderColor="transparent"
                    borderColorHover="transparent"
                    margin="0px 3rem 0px 0px"
                    height="unset"
                    minWidth="124px"
                    padding="1rem 2rem"
                    display="inline-block"
                    textAlign="center"
                    lineHeight="1.5"
                    letterSpacing=".1rem"
                    transition="all .3s"
                >
                    Cancelar
                </c-button>
                <c-button
                    data-dismiss="modal"
                    :backgroundColor="
                        $root.$children[0].theme.products.button
                            .background_color
                    "
                    :backgroundColorHover="
                        $root.$children[0].theme.products.button
                            .background_color_hover
                    "
                    :color="$root.$children[0].theme.products.button.color"
                    :colorHover="
                        $root.$children[0].theme.products.button.color_hover
                    "
                    :borderColor="
                        $root.$children[0].theme.products.button.border_color
                    "
                    :borderColorHover="
                        $root.$children[0].theme.products.button
                            .border_color_hover
                    "
                    :borderRadius="
                        $root.$children[0].theme.products.button.border_radius
                    "
                    margin="0px 3rem 0px 0px"
                    textTransform="uppercase"
                    height="unset"
                    minWidth="124px"
                    padding="1rem 2rem"
                    display="inline-block"
                    textAlign="center"
                    lineHeight="1.5"
                    letterSpacing="unset"
                    transition="all .3s"
                >
                    OK
                </c-button>
            </div>
        </ModalApp>
    </div>
</template>

<script>
import ModalApp from "../ModalApp.vue";
import { CHeading3, CHeading4, CParagraph } from "../Styles/Components/styled";
import { CButton } from "../Styles/Button/styled";
import Currency from "../../helpers/parseCurrency";
import { mapActions, mapState } from "vuex";
export default {
    name: "CompletedPurchase",
    components: {
        ModalApp,
        "c-button": CButton,
        "c-heading-3": CHeading3,
        "c-paragraph": CParagraph,
        "c-heading-4": CHeading4
    },
    props: {
        purchase: { required: true },
        gateway: { required: true }
    },
    data() {
        return {
            pix_data: {
                payload_pix: null
            },
            url_pix: "",
            currency: Currency
        };
    },
    mounted() {
        console.log(this.gateway)
        if(this.gateway?.name === 'PIX' || this.gateway?.name === 'BELLUNO PIX') {
            setTimeout(this.showModalPix, 1500)
        }
    },
    methods: {
        ...mapActions("toast", [
            "setShowToast",
            "setMessageToast",
            "setTimerToast",
            "setIconToast",
            "setThemeToast"
        ]),
        onCopyPix: function(e) {
            this.alertToast(
                "Chave copiada para a área de transferência!",
                "check",
                "success"
            );
        },
        onErrorPix: function(e) {
            this.alertToast(
                "Não foi possível copiar a chave!",
                "exclamation-triangle",
                "danger"
            );
        },
        showModalPix() {
            let payload_pix = ''
            if(this.purchase.payload) {
                payload_pix = JSON.parse(this.purchase?.payload).payload_pix
            }
            this.$root.showModalApp("pix_modal");
            this.$set(this.pix_data, "payload_pix", payload_pix);
        },
        alertToast(
            msg = null,
            icon = "exclamation",
            theme = "warning",
            timer = 7
        ) {
            this.setThemeToast(theme);
            this.setMessageToast(msg);
            this.setIconToast(icon);
            this.setTimerToast(timer);
            this.setShowToast(true);
            setTimeout(() => {
                this.setShowToast(false);
            }, timer * 1000);
        }
    },

};
</script>
